import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

@Module({ dynamic: true, store, name: 'viewState', namespaced: true })
class ViewEditingState extends VuexModule {
  private 画面を編集中: boolean = false;

  public get 画面を編集中である(): boolean {
    return this.画面を編集中;
  }

  @Mutation
  public setEditing(画面を編集中: boolean): void {
    this.画面を編集中 = 画面を編集中;
  }

  @Action
  public 初期化する(): void {
    this.setEditing(false);
  }

  @Action
  public 画面の編集を開始する(): void {
    this.setEditing(true);
  }

  @Action
  public 画面の編集を終了する(): void {
    this.setEditing(false);
  }
}

export const viewEditingStateModule = getModule(ViewEditingState);
